export default __webpack_public_path__ + "static/media/Social Links.ae11d69b.svg";